import { createContext } from "react";
import {
  DEFAULT_TRANSLATION_LANGUAGES,
  TranslationContextInterface,
} from "../entities/Language";

export const TranslationContext: any =
  createContext<TranslationContextInterface>({
    translations: {},
    contextLanguage: DEFAULT_TRANSLATION_LANGUAGES.US,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setContextLanguage: (languageShortName: string) => {},
  });
